import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';
import { fetchModel } from '../utils';
import GuideService from '../service/GuideService';

Vue.use(Vuex)

const DEFAULT_DISMISS_TIME_ALERT = 5;

export default new Vuex.Store({
  state: {
    defaultLanguage: { id: 1, name: 'Português', symbol: 'Pt' },
    languages: [],
    user: {
      id: '',
      email: '',
      name: '',
      active: false,
      acceptedTermsDate: null,
      hasSavedProfileInfo: false,
      city: undefined
    },
    show: {
      title: false,
      loading: false
    },
    ref: {
      loading: {
        count: 0
      }
    },
    alert: {
      show: false,
      message: '',
      style: '',
      code: 0
    },
    invalidInput: undefined
  },
  getters: {
    isAuthenticated: () => !!window.localStorage.getItem('token'),
    loadingValue: state => state.show.loading,
    showAlert: state => state.alert.show,
    alertMessage: state => state.alert.message,
    alertStyle: state => state.alert.style,
    user: state => state.user,
    hasAcceptedTerms: (state) => {
      var acceptedTermsDate = moment(state.user.acceptedTermsDate, "DD/MM/YYYY HH:mm:ss");
      var manualModificationDate = moment(window.localStorage.getItem('manualModificationDate'), "DD/MM/YYYY HH:mm:ss");
      return acceptedTermsDate.isAfter(manualModificationDate);
    },
  },
  mutations: {
    showTitle(state, show) {
      state.show.title = show
    },
    LOGIN: (state, { token }) => {
      window.localStorage.setItem('token', token)
    },
    LOGOUT: (state) => {
      state.user = { email: '', name: '' }
      window.localStorage.removeItem('token')
    },
    loadUserInfo: (state, user) => {
      state.user = {
        id: user.id,
        email: user.email,
        name: user.name,
        acceptedTermsDate: user.acceptedTermsDate,
        hasSavedProfileInfo: user.hasSavedProfileInfo
      };
    },
    showLoading: (state, show) => {
      if (show) {
        state.ref.loading.count++;
        state.show.loading = true;
      } else if (state.ref.loading.count > 0) {
        state.ref.loading.count--;
        state.show.loading = (state.ref.loading.count > 0);
      }
    },
    showAlert: (state, { message, code, style, show }) => {
      if (show === undefined) show = DEFAULT_DISMISS_TIME_ALERT;
      state.alert = { message, code, style, show };
    },
    invalidInput(state, inputElement) {
      state.invalidInput = inputElement;
    },
    languages(state, languages) {
      state.languages = languages;
    },
    user: (state, user) => state.user = user,
    setManualModificationDate(state, date) {
      window.localStorage.setItem('manualModificationDate', date)
    },
  },
  actions: {
    showTitle(context, show) {
      context.commit("showTitle", show)
    },
    showLoading: (context, show) => {
      context.commit("showLoading", show)
    },
    showAlert: (context, { message, code, style, show }) => {
      context.commit("showAlert", { message, code, style, show });
    },
    hideAlert: (context) => {
      context.commit("showAlert", { message: '', code: 0, style: '', show: false });
    },
    async loadUserInfo(context, user) {
      await context.commit("loadUserInfo", user);
    },
    login(context, { token }) {
      context.commit("LOGIN", { token });
    },
    logout(context) {
      context.commit("LOGOUT")
    },
    invalidInput({commit}, inputElement) {
      commit('invalidInput', inputElement);
    },
    async fetchLanguages({commit}) {
      let languages = await fetchModel('idiomas', () => new LanguageService().list());
      commit('languages', languages);
    },
    async fetchManualModificationDate({commit}) {
      let {data} = await new GuideService().manual();
      commit('setManualModificationDate', data.modificationDate);
    }
  }

})



// WEBPACK FOOTER //
// ./src/store/store.js